<template>
	<div class="text-center">
		<v-dialog v-model="dialog" width="80%">
			<v-card>
				<v-card-title class="text-h5 bk-main lighten-2"> 回答内容確認</v-card-title>
				<div class="pa-2">
					<table>
						<RequirementConfirmRecord
							v-for="(column, index) in answerTemplate.answer_columns"
							:key="column.id"
							:column="column"
							:name="column.name"
							:value="valueByColumn(answerValues[index], column)"
							:wrapFlag="column.data_type == 'text' ? true : false"
							:fullCheckFLag="answerTemplate.full_check_flag"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
						<RequirementConfirmRecord
							:name="`伝達事項`"
							:value="answer.message"
							:fullCheckFLag="answerTemplate.full_check_flag"
							:column="{ data_type: '' }"
							:wrapFlag="true"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
					</table>
				</div>
				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialog = false"> 戻る </v-btn>
					<v-btn
						v-if="!answerApprovalFlag && !answerConfirmationFlag"
						color="primary"
						text
						@click="createAnswer('draft')"
					>
						下書き保存
					</v-btn>
					<v-btn
						v-if="
							(answerApprovalFlag && !answerTemplate.full_check_flag) ||
							(answerTemplate.full_check_flag && answerApprovalFlag && isDisableConfirmFlag)
						"
						color="primary"
						text
						@click="approveAnswer(requirement.id)"
					>
						承認する
					</v-btn>
					<v-btn
						v-else-if="
							(answerConfirmationFlag && !answerTemplate.full_check_flag) ||
							(answerTemplate.full_check_flag && answerConfirmationFlag && isDisableConfirmFlag)
						"
						color="primary"
						text
						@click="confirmAnswer(requirement.id)"
					>
						確認する
					</v-btn>
					<v-btn
						color="primary"
						v-else-if="
							answerTemplate.full_check_flag == false ||
							(answerTemplate.full_check_flag == true && isDisableConfirmFlag)
						"
						text
						@click="createAnswer('confirm')"
					>
						{{ common.setAnswerConfirmWord(answerTemplate) }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<IndeterminateLoadingView :isLoading="isLoading" />
	</div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import RequirementConfirmRecord from "../../requirement/components/RequirementConfirmRecord.vue"
import IndeterminateLoadingView from "../../shared/IndeterminateLoadingView.vue"
export default {
	components: {
		RequirementConfirmRecord,
		IndeterminateLoadingView,
	},
	props: {
		answerApprovalFlag: Boolean,
		answerConfirmationFlag: Boolean,
	},
	data() {
		return {
			isLoading: false,
			headers: [],
			dialog: false,
			common: common,
			checkedNumber: 0,
			checkMaxNumber: 0,
			isDisableConfirmFlag: false,
			requirement: {},
			answer: { message: "" },
			answerValues: [],
			answerTemplate: { id: "", answer_columns: [] },
		}
	},
	mounted() {},
	watch: {
		checkedNumber() {
			if (this.checkedNumber == this.checkMaxNumber) {
				this.isDisableConfirmFlag = true
			} else {
				this.isDisableConfirmFlag = false
			}
		},
	},
	methods: {
		openDialog(answer, values, requirement, template) {
			console.log(answer, values, requirement, template)
			this.dialog = true
			this.answer = answer
			this.answerValues = values
			this.requirement = requirement
			this.answerTemplate = template
		},
		createAnswer(word) {
			this.isLoading = true
			let status_id = ""
			if (word == "draft") {
				status_id = "draft"
			} else if (word == "confirm" && this.answerTemplate.need_check_flag) {
				status_id = "waiting_confirmation"
			} else if (word == "confirm" && this.answerTemplate.need_approval_flag) {
				status_id = "waiting_approval"
			} else {
				status_id = "sent"
			}
			const headers = authenticate.setHeader()
			headers["content-type"] = "multipart/form-data"
			const formData = new FormData()
			let mainParams = {
				message: this.answer.message,
				requirement_id: this.requirement.id,
				answer_template_id: this.answerTemplate.id,
				status_id: status_id,
			}

			let fileValues = []
			const answerValues = _.cloneDeep(this.answerValues)
			let otherParams = answerValues.map((v) => {
				if ("value_file" in v) {
					if (v.value_file != null) {
						let valueFiles = v.value_file.map((file) => ({
							file: file,
							column_id: v.answer_column_id,
						}))
						fileValues = fileValues.concat(valueFiles)
					}
					delete v.value_file
				} else if ("name" in v) {
					delete v.name // アソシエーション先の表示名を削除
					delete v.value_target
				} else if ("display_value" in v) {
					delete v.display_value
				}
				return v
			})

			formData.append("answer", JSON.stringify(mainParams))
			formData.append("values", JSON.stringify(otherParams))
			axios
				.post("/erp/v1/answers", formData, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "作成しました",
						type: "notice",
					})
					fileValues.forEach((file) => {
						this.valueAttachedFileUpload(file, res.data)
					})
					this.dialog = false
					this.$router.push({
						name: "answers",
						params: { department_id: this.requirement.to_department_id },
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
				.finally(() => (this.isLoading = false))
		},
		valueAttachedFileUpload(valueData, values) {
			const value = values.find((v) => v.answer_column_id == valueData.column_id)
			if (!value) return
			const headers = authenticate.setHeader()
			headers["content-type"] = "multipart/form-data"
			const formData = new FormData()
			formData.append("value", JSON.stringify({ id: value.id }))
			formData.append("file", valueData.file)
			axios
				.post("/erp/v1/answer_values/files", formData, { headers })
				.then((res) => {})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		addCheckedCounter() {
			this.checkedNumber += 1
		},
		removeCheckedCounter() {
			this.checkedNumber -= 1
		},
		addMaxCounter() {
			this.checkMaxNumber += 1
		},
		approveAnswer(id) {
			this.$emit("approveAnswer", id)
			this.dialog = false
		},
		confirmAnswer(id) {
			this.$emit("confirmAnswer", id)
			this.dialog = false
		},
		valueByColumn(value, column) {
			if (this.answerApprovalFlag || this.answerConfirmationFlag) {
				const answerValue = this.answerValues.find((v) => v.answer_column_id == column.id)
				if (!answerValue) {
					return null
				} else if (column.data_type == "file") {
					return answerValue.attached_files
				} else if (column.data_type == "synchronization") {
					return answerValue.value
				} else {
					return common.value(column, answerValue.value)
				}
			} else {
				switch (column.data_type) {
					case "target":
						return value.name
					case "boolean":
						return common.returnMaruBatsu(value.value_boolean)
					case "date":
						return common.formatDate(value.value_date)
					case "synchronization":
						return value.display_value
					default:
						return value[`value_${column.data_type}`]
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";
.bk-main {
	background-color: $main-color;
	color: white;
}
table {
	width: 100%;
}
</style>
